module.exports = __webpack_public_path__ + "img/流体力学_講師画像_山崎先生.174fdc5b.jpg";